import { Injectable, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { of } from "rxjs";
import { first, takeUntil } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class StorageService implements OnDestroy {
  constructor() {}
  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  store<T>(data: T, msg: string, expirationDurationInSeconds: number): void {
    let key = msg;
    localStorage.setItem(
      key,
      JSON.stringify(new CacheWrapper<T>(data, expirationDurationInSeconds))
    );
  }
  getItem<T>(msg: string): T {
    let key = msg;
    let value = localStorage.getItem(key);

    var cached = JSON.parse(value) as CacheWrapper<T>;

    if (cached != null && cached.expiration < new Date()) {
      localStorage.removeItem(key);
      return undefined;
    }

    if (cached == null) return undefined;

    return cached.item;
  }

  getOrCreateItem<T, U>(
    id: string,
    creator: (id: string) => Observable<T>,
    maxAgeInSeconds: number
  ): Observable<T> {
    let cached = this.getItem<T>(id);

    if (cached != undefined) return of<T>(cached);

    let obs = creator(id);
    obs
      .pipe(first())
      .subscribe((data) => this.store<T>(data, id, maxAgeInSeconds));

    return obs;
  }
}

class CacheWrapper<T> {
  constructor(item: T, expirationDurationInSeconds: number) {
    this.item = item;
    let expires = new Date();
    expires.setSeconds(expires.getSeconds() + expirationDurationInSeconds);
    this.expiration = expires;
  }

  public item: T;
  public expiration: Date;
}
